import { AUTH_TOKEN } from '@store/types'
import store from '@store'

if (process.env.NODE_ENV === 'development') {
  window.changeUser = (company = 0) => {
    const companies = ['convenia']
    const data = [
      {
        t: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI3MDQyZjdhMC1kYzRjLTExZTctYWU5YS0wMzI2NWM4YTAxZmIiLCJpc3MiOiJodHRwOi8vY2x1YmVjb3JlLmNvbnZlbmlhLmNvbS5ici9hZG1pbi92MS9hdXRoZW50aWNhdGUiLCJpYXQiOjE1MTI5ODkxMTYsImV4cCI6MTUxNDI4NTExNiwibmJmIjoxNTEyOTg5MTE2LCJqdGkiOiJDRFZuaER3ejZQaXdYRkU2In0.vmZLoSkt-Iq3PohWVZSTWJjkJ3JSXq1NpWCtGqyvhdE',
        c: '05d93820-d8f1-11e7-b815-6dd16d771557'
      }
    ]
    if (typeof company === 'string') {
      company = companies.indexOf(company.toLowerCase())
    }
    store.dispatch(AUTH_TOKEN, data[company].t)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/changeUser.js